<form
  *ngIf="(state$ | async)?.form as form"
  [formGroup]="form"
  class="form">
  <mat-form-field>
    <input
      matInput
      formControlName="username"
      [placeholder]="'Username' | translate">
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{ 'Ruolo' | translate }}</mat-label>
    <mat-select formControlName="role">
      <mat-option></mat-option>
      <mat-option
        *ngFor="let r of (state$ | async)?.roles"
        [value]="r.id">
        {{ r.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</form>
